import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class FilterUtilityService {
  constructor() {}

  public getControlWithStatus(
    controls: AbstractControl[],
    status: 'invalid' | 'touched' | 'valid'
  ): AbstractControl {
    return controls.find((control) => control[status]);
  }
}
